<script>
import { onDestroy, createEventDispatcher } from 'svelte';
import WaveSurfer from 'wavesurfer.js';
import { RecordingStatus, PreviewStatus } from './utils/enum';
export let currentRecordingStatus;
export let currentPreviewStatus;
export let onTimeUpdate;

let wavesurfer = null;
let mediaRecorder = null;
let audioChunks = [];
let stream = null;

const dispatch = createEventDispatcher();

const createWavesurfer = () => {
  if (wavesurfer) wavesurfer.destroy();
  wavesurfer = WaveSurfer.create({
    container: '#waveform',
    height: 'auto',
    barWidth: 6,
    barHeight: 2,
    barRadius: 2,
    interact: false,
    cursorColor: '#D05E5E',
    cursorWidth: 2,
    waveColor: '#BEA1E1',
    progressColor: 'rgba(57, 121, 195, 0.5)'
  });

  wavesurfer.on('audioprocess', () => {
    if (onTimeUpdate) onTimeUpdate(wavesurfer.getCurrentTime());
  });
  wavesurfer.on('finish', () => {
    dispatch('pause');
  });
};

const startRecording = async () => {
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        sampleRate: 256000,
        channelCount: 1
      }
    });
    mediaRecorder = new MediaRecorder(stream, { mimeType: 'video/mp4' });
    mediaRecorder.ondataavailable = (event) => {
      audioChunks.push(event.data);
    };
    mediaRecorder.onstop = async() => {
      const audioBlob = new Blob(audioChunks, { type: 'video/mp4' });
      await wavesurfer.loadBlob(audioBlob);
      dispatch('recorded', { blob: audioBlob, duration: wavesurfer.getDuration() });
      audioChunks = [];
      stream.getTracks().forEach(track => track.stop());
      stream = null;
    };
    mediaRecorder.onerror = (error) => {
      console.error('Recording error:', error);
    };
    mediaRecorder.start();
  } catch (error) {
    console.error('Error accessing media devices.', error);
  }
};

const stopRecording = () => {
  if (mediaRecorder) {
    mediaRecorder.stop();
  }
};

$: if (currentRecordingStatus === RecordingStatus.RECORDING) {
  createWavesurfer();
  startRecording();
} else {
  stopRecording();
}

$: if (wavesurfer && currentPreviewStatus === PreviewStatus.PAUSE) {
  wavesurfer.pause();
} else if (wavesurfer) {
  wavesurfer.play();
}

onDestroy(() => {
  if (wavesurfer) wavesurfer.destroy();
  if (mediaRecorder && mediaRecorder.state !== 'inactive') {
    mediaRecorder.stop();
  }
  if (stream) {
    stream.getTracks().forEach(track => track.stop());
  }
});
</script>

<div class="relative flex items-center justify-center w-full h-full bg-black">
  {#if currentRecordingStatus === RecordingStatus.RECORDING}
    <div class="recording fixed m-auto"></div>
  {/if}
  <div id="waveform" class="w-full h-1/2"></div>
</div>
